import { Providers } from './providers';
import { AppRouter } from './Router';

export default function App() {
  return (
    <Providers>
      <AppRouter />
    </Providers>
  );
}
